import { render, staticRenderFns } from "./DatePickerDateOfBirth.vue?vue&type=template&id=0f0bcd38&scoped=true&"
import script from "./DatePickerDateOfBirth.vue?vue&type=script&lang=js&"
export * from "./DatePickerDateOfBirth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0bcd38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VMenu,VTextField})
